import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocGroupPolicyRoute: InvariantJiraRoute = {
	name: 'eoc-group-policy',
	path: '/jira/ops/teams/:teamId/group-policy',
	exact: true,
};
